import { ethers } from "ethers";
import {
  nils,
  iso,
  nano,
  tofeth,
  toeth,
  tofpval,
  blocktime_iso,
  base64_to_json,
} from "../../utils/utils.jsx";
import _ from "lodash";
import abi from "./abis/DNA_SkinsStore_BulkGetter.json";
import { CV2_Contract } from "./cv2_base.js";
import { contractAddress_list } from "../contracts.jsx";

const k = "dnaskinsstorebulkgetter";
class Contract extends CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    super({ contract_k, contractAddress, aumode, abi, ...ext });
  }

  async getParsedLogs(logs) {
    if (!logs) return [];

    let logrows = [];
    for (let log of logs) {
      let iface = new ethers.Interface(this.abi);
      let par = iface.parseLog(log);

      if (nils(par)) continue;

      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;

      // This contract mainly has view functions, so fewer events expected
      // Add event parsing here if needed in the future

      logrows.push(o);
    }
    return logrows;
  }
}

const get_contract_address = () => {
  return contractAddress_list.skinsstorebulkgetter;
};

const get_contract = async (ext = {}) => {
  const contractAddress = get_contract_address();
  const runner = new Contract({
    contract_k: k,
    contractAddress,
    aumode: ext.aumode || "thirdweb",
    abi,
    ...ext,
  });
  return runner;
};

const DNA_SkinsStore_BulkGetter = {
  k,
  get_contract,
  get_contract_address,
};

export default DNA_SkinsStore_BulkGetter;
